export default {
  employee: {},
  reincorporationDate: '',
  absenceType: '',
  days: '',
  endDate: '',
  startDate: ''
};
